const styles = {
  text: {
    marginBottom: '0.5rem',
    wordBreak: 'break-word',
  }
}

export default styles
